var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,16.8H4.2c-0.2,0-0.5-0.1-0.6-0.3s-0.3-0.4-0.3-0.6V4.2c0-0.2,0.1-0.5,0.3-0.6s0.4-0.3,0.6-0.3h3.3 c0.4,0,0.8-0.3,0.8-0.8S7.9,1.8,7.5,1.8H4.2C3.5,1.8,2.9,2,2.5,2.5S1.8,3.5,1.8,4.2v11.7c0,0.6,0.3,1.3,0.7,1.7 c0.5,0.5,1.1,0.7,1.7,0.7h3.3c0.4,0,0.8-0.3,0.8-0.8S7.9,16.8,7.5,16.8z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.2,10C18.2,10,18.2,10,18.2,10C18.2,10,18.2,10,18.2,10c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.1-0.1-0.2 c0,0,0,0,0-0.1l-4.2-4.2c-0.3-0.3-0.8-0.3-1.1,0s-0.3,0.8,0,1.1l2.9,2.9H7.5c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h8.2l-2.9,2.9 c-0.3,0.3-0.3,0.8,0,1.1c0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2l4.2-4.2c0.1-0.1,0.1-0.2,0.2-0.2C18.2,10.2,18.2,10.1,18.2,10 C18.2,10,18.2,10,18.2,10z",
    fill: "currentColor"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.2870f7a8.svg";
export { ForwardRef as ReactComponent };